import React from 'react';
import { Colors } from 'works/legacy/lib/style-helper';

export const DrawerTitle = ({ children }: { children: React.ReactNode }) => (
  <>
    <div className="drawer-title">{children}</div>
    <style jsx>
      {`
        .drawer-title {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          font-size: 16px;
          line-height: 22px;
          padding: 16px 24px 16px 24px;
          border-bottom: solid 1px ${Colors.steelLighter};
        }
      `}
    </style>
  </>
);
